import Button from "@xtribe/shared/components/lib/Button";
import Modal from "@xtribe/shared/components/lib/Modal";
import useModal from "@xtribe/shared/components/lib/Modal/use-modal";
import BorderBottomLink from "../lib/Links/BorderBottomLink";
import Link from "../lib/Links/Link";

const InviteCodeModal = ({}) => {
  const { visible, setVisible, bindings } = useModal();
  return (
    <div>
      <div className="h-1" />
      <Link htmlType="div" onClick={() => setVisible(true)}>
        Ich habe keinen Einladungscode
      </Link>
      <Modal onClose={() => setVisible(false)} open={visible} width="40rem">
        <Modal.Title>Einladungscode xTribe</Modal.Title>
        <Modal.Content>
          <p className="text-foreground-soft">
            Wir wollen die vielseitigste und leidenschaftlichste Plattform
            werden, die wir uns vorstellen können. Daher ist es uns wichtig,
            ausgewählte und bunte Creater auf xTribe willkommen zu heißen, und
            gleichzeitig im engen Kontakt zu jedem von euch zu stehen.
          </p>
          <h4 className="subheading mt-8">
            Wie bekomme ich einen Einladungscode?
          </h4>
          <p className="mt-2 text-foreground-soft">
            Du kriegst einen Einladungscode entweder von einem/einer bestehenden
            xTribe-LeaderIn, oder nachdem du unser Onboarding durchlaufen hast &
            wir die Chance hatten dich und dein Vorhaben in einem kurzen
            Telefonat besser kennenzulernen.{" "}
          </p>
          <div className="h-2" />
          <BorderBottomLink href={`${process.env.NEXT_PUBLIC_SITE_URL}/start`}>
            Hier geht's zum Onboarding
          </BorderBottomLink>
        </Modal.Content>
        <Modal.Action onClick={() => setVisible(false)}>Schließen</Modal.Action>
      </Modal>
    </div>
  );
};

export default InviteCodeModal;
